import * as React from 'react';
import * as b_ from 'b_';
import { Idea } from '../../../../types';
import Authentication from '../Authentication';
import Finished from '../Finished';
import Submit from '../Submit';
import { Deposit } from '../Deposit';
import { Notification } from '../IpoNotification';
import { useSubmitSectionValues } from './hooks';
import { ActiveOrder } from '../ActiveOrder';

import './styles.scss';

const b = b_.with('idea-landing-submit-section-content');

export interface Props {
  idea: Idea;
  isExpired: boolean;
  activeOrderId: number | undefined;
}

export const Content: React.FC<Props> = ({ idea, isExpired, activeOrderId }) => {
  const { isAuthenticated, balance, min, max } = useSubmitSectionValues(idea);

  if (isExpired) {
    return <Finished />;
  }

  if (!isAuthenticated) {
    return <Authentication ideaId={idea.id} ideaName={idea.name} />;
  }

  if (activeOrderId) {
    return <ActiveOrder ideaType={idea.ideaType} id={activeOrderId} />;
  }

  if (balance.value < idea.enterAmount.value) {
    return (
      <div className={b('row')}>
        <Deposit idea={idea} balance={balance} />
      </div>
    );
  }

  return (
    <div className={b('row')}>
      <Submit idea={idea} balance={balance} min={min} max={max} initialAmount={min} />
      {idea.category === 'IPO' && <Notification />}
    </div>
  );
};
